<div class="body">

    <ng-container *ngIf="appearance === 'raw'; else wrapped">

        <mat-select [formControl]="valueControl" class="width">

            <mat-option *ngFor="let type of (service.contactInformationTypes$|async)" [value]="type.typeid">
                {{type.typename}}
            </mat-option>

        </mat-select>

    </ng-container>

</div>

<ng-template #wrapped>

    <mat-form-field class="form-field mat-form-input-without-bottom-padding" [appearance]="appearance">

        <mat-label>
            {{label}}
        </mat-label>

        <mat-select [formControl]="valueControl" class="width">

            <mat-option *ngFor="let type of (service.contactInformationTypes$|async)" [value]="type.typeid">
                {{type.typename}}
            </mat-option>

        </mat-select>

    </mat-form-field>

</ng-template>